import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Eye, EyeOff } from "lucide-react";

/**
 * Password input with a built-in show/hide eye toggle.
 * Manages its own visibility state so both fields on /register can toggle independently.
 * All standard <Input> props pass through — id, value, onChange, required, minLength, etc.
 */
export default function PasswordInput({ id, testId, toggleTestId, ...inputProps }) {
    const [show, setShow] = useState(false);
    return (
        <div className="relative">
            <Input
                id={id}
                type={show ? "text" : "password"}
                data-testid={testId}
                {...inputProps}
                className={`pr-10 ${inputProps.className || ""}`}
            />
            <button
                type="button"
                onClick={() => setShow((v) => !v)}
                aria-label={show ? "Hide password" : "Show password"}
                aria-pressed={show}
                tabIndex={-1}
                className="absolute inset-y-0 right-0 flex items-center px-3 text-muted-foreground hover:text-foreground focus:outline-none focus-visible:text-foreground"
                data-testid={toggleTestId}
            >
                {show ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
            </button>
        </div>
    );
}
